import React, { useState } from "react";
import "../assets/css/FAQPage.css";
const faqs = [
  {
    question: "What is BackupMeraki?",
    answer:
      "BackupMeraki is a fully managed cloud service that automates the backup and restoration of your Cisco Meraki Dashboard configurations. ",
  },
  {
    question:
      "Why do I need to back up my Cisco Meraki Dashboard configuration?",
    answer:
      "Accidental changes, malicious deletions, or unforeseen events can lead to costly downtime. If  something goes wrong — such as a misconfiguration or deleted settings — you can quickly  restore your configuration instead of rebuilding it from scratch.",
  },
  {
    question: "What is your tool able to back up?",
    answer:
      "We can back up roughly 95% of your Meraki configuration, covering organization-wide,  network-wide, and device-specific settings. Essentially, if it’s accessible through the Cisco  Meraki Dashboard API, we’ll include it in the backup. ",
  },
  {
    question: "What level of access does BackupMeraki require?",
    answer:
      "You only need read-only full organization credentials for routine backups. If you wish to restore  configurations, you can temporarily provide a read-write API key to carry out the changes. Once  the restore is finished, you can revert to using a read-only key for subsequent backups. ",
  },
   {
    question: "Can I schedule automatic backups?",
    answer:
      " Yes. You can set up daily, weekly, or monthly backups to run automatically. If you ever need an  immediate snapshot, you can also trigger an on-demand backup at any time.",
  },
  {
    question: "What level of restore is available?",
    answer: [
      {
        type: "text",
        content:
          "Currently, we support two partial restore modes that target specific parts of your Cisco Meraki Dashboard, helping you minimize overall impact:",
      },
      {
        type: "listWithBold",
        items: [
          {
            label: "Organization-wide restore:",
            desc: " Rolls back all organization-level settings.",
          },
          {
            label: "Network-wide restore:",
            desc: " Restores network-wide settings and device-specific configurations under a particular network.",
          },
        ],
      },
    ],
  },
   {
    question: "Is there a limit to how many backups I can store?",
    answer:
      " By default, we retain backups for at least 1 year. If you need extended retention or have  large-scale archival requirements, please reach out to discuss a tailored solution. ",
  },
   {
    question: "Where is my data stored?",
    answer:
      "You can select from one of 11 global regions for data storage. We use AWS cloud infrastructure  to ensure global availability, data redundancy, and low latency, allowing you to pick a location  that best meets your compliance and performance needs.",
  },
   {
    question: "Is my backup data encrypted?",
    answer:
      "Absolutely. We encrypt your data in transit (during upload/download) and at rest (in our cloud  storage). Your API keys are also encrypted so that no one, including our staff, can see them in  plaintext. ",
  },
   {
    question: "What if I need to comply with data residency requirements?",
    answer:
      "By allowing you to choose the AWS region where your data is stored, BackupMeraki helps  satisfy data residency and governance requirements specific to your industry or location.",
  },
   {
    question: "Does BackupMeraki store logs of all changes?",
    answer:
      "We keep a full Backup History and provide a detailed report whenever you perform a restore,  showing which settings changed and any that couldn’t be updated. For additional details on  actual configuration changes, refer to the Organization > Change Log in your Cisco Meraki  Dashboard. ",
  },
   {
    question: "What happens if I cancel my subscription or want to delete my data?",
    answer:
      "You can delete your data at any time (both backup data and API key). If you decide to cancel,  we permanently remove all your backups and credentials from our systems.",
  },
   {
    question: "Is there a free trial or demo available?",
    answer:
      "Yes! We offer a 30-day free trial with full features enabled. You can explore backups, partial  restores, and all other aspects of the service at no cost. ",
  },
   {
    question: "How do I get started with BackupMeraki?",
    answer:
      "Simply sign up for an account, choose your preferred region for data storage, and add your  Meraki API keys. You can then schedule your first backup or run an on-demand backup  immediately. ",
  },
  {
    question: "Who can I contact for support?",
    answer: [
      {
        type: "text",
        content:
          "We offer email support at contact@backupmeraki.com, available from 7:00 AM to 10:00 PM AEST (UTC+11).",
      },
      {
        type: "text",
        content: "In other time zones, this corresponds to:",
      },
      {
        type: "list",
        items: [
          "US Eastern Time (UTC-5): 3:00 PM – 6:00 AM",
          "US Pacific Time (UTC-8): 12:00 PM – 3:00 AM",
          "United Kingdom (UTC+0): 8:00 PM – 11:00 AM",
          "UAE (UTC+4): 12:00 AM – 3:00 PM",
          "Singapore (UTC+8): 4:00 AM – 7:00 PM",
        ],
      },
      {
        type: "note",
        content:
          "These time windows may vary by an hour during daylight saving transitions.",
      },
      {
        type: "text",
        content:
          "If you have questions outside these hours, feel free to email us, and we’ll get back to you as soon as possible.",
      },
    ],
  },
   
];

const FAQPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null); 
    } else {
      setActiveIndex(index); 
    }
  };

  return (
    <section className="faq-section py-5 section-main">
  <div className="container">
    <h1 className="text-center mb-4 heading-faq-main">Frequently Asked Questions</h1>

    <div className="accordion main-mapping-div">
      {faqs.map((faq, index) => (
        <div key={index} className="mb-3 question-main-div">
          
          
          <div
            className="p-3 d-flex justify-content-between align-items-center faq-question question-inner-div"
            onClick={() => toggleFAQ(index)}
            style={{ cursor: "pointer" }}
          >
            <h5 className="mb-0 qust-heading-tag">{faq.question}</h5>
            <span>{activeIndex === index ? "−" : "+"}</span>
          </div>

          
          {activeIndex === index && (
            <div className="p-3 border-bottom faq-answer answer-main-div">
              {Array.isArray(faq.answer) ? (
                faq.answer.map((item, i) => {
                  if (item.type === "text") {
                    return <p key={i}>{item.content}</p>;
                  }
                  if (item.type === "list") {
                    return (
                      <ul key={i}>
                        {item.items.map((li, j) => (
                          <li key={j}>{li}</li>
                        ))}
                      </ul>
                    );
                  }
                  if (item.type === "note") {
                    return (
                      <p key={i} className="text-muted fst-italic">
                        {item.content}
                      </p>
                    );
                  }
                  if (item.type === "listWithBold") {
                    return (
                      <ul key={i}>
                        {item.items.map((li, j) => (
                          <li key={j}>
                            <strong>{li.label}</strong>
                            {li.desc}
                          </li>
                        ))}
                      </ul>
                    );
                  }
                  return null;
                })
              ) : (
                <p>{faq.answer}</p>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
</section>

  );
};

export default FAQPage;
